import classNames from 'classnames';
import PropTypes from 'prop-types';

import { generateQeId } from '@ctct/ui-react';

const propTypes = {
  className: PropTypes.string,
  /** Identifier used by QE */
  'data-qe-id': PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  classes: PropTypes.arrayOf(PropTypes.string),
  classBase: PropTypes.string,
  innerStyle: PropTypes.shape({}),
};

const defaultProps = {
  className: '',
  classes: [],
  classBase: '',
  value: '',
  innerStyle: null,
};

const InfoRow = (props) => {
  const { 'data-qe-id': qeId, label, value, classBase, innerStyle, ...attributes } = props;

  return (
    <div {...attributes} className="upgrade-order-summary-section-row">
      <span
        className={classNames(`upgrade-order-summary-${classBase}-label`, 'upgrade-order-summary-body-left')}
        data-qe-id={generateQeId(qeId, classBase)}
        style={{ color: '#333333', ...innerStyle }}
      >
        {label}
      </span>
      <span
        className={classNames(`upgrade-order-summary-${classBase}-value`, 'upgrade-order-summary-body-right')}
        data-qe-id={generateQeId(qeId, `${classBase}-value`)}
      >
        {value}
      </span>
    </div>
  );
};

InfoRow.propTypes = propTypes;
InfoRow.defaultProps = defaultProps;

export default InfoRow;
